<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent != null && localService.languageContent.field_config != undefined">
  <app-popup-header title="{{localService.languageContent.field_config.header}}"></app-popup-header>
  <div class="modal-body" *ngIf="wrapper != undefined" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-4">
        {{localService.languageContent.field_config.type}}
      </div>
      <div class="col-8">
        <ngx-select [(ngModel)]="wrapper.content.v1" [optionValueField]="'key'" [optionTextField]="'v3'" [items]="types"
          placeholder="{{localService.languageContent.field_config.select_type}}" [noAutoComplete]="true">
        </ngx-select>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <label>Reference Key:</label>
      </div>
      <div class="col-6">
        <input autocomplete="off" type="text" class="en" [(ngModel)]="wrapper.content.v3" placeholder="Reference Key"
          title="Reference Key" (keydown.enter)="onLoad()" />
      </div>
    </div>
    <app-language-container [MaxLength]="30" [(languageContents)]="wrapper.languageContents"
      (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event)"
      [IsShowAllLanguages]="true"></app-language-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary"
      (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>